var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5002 7.563C16.5002 10.758 14.5702 13.5 12.0002 13.5C9.42822 13.5 7.50022 10.758 7.50022 7.562C7.50022 4.368 9.16022 2.5 12.0002 2.5C14.8402 2.5 16.5002 4.367 16.5002 7.563ZM4.10222 20.642C4.48722 21.1 6.14522 22.5 12.0002 22.5C17.8552 22.5 19.5122 21.1 19.8982 20.643C19.934 20.5991 19.9605 20.5483 19.9759 20.4938C19.9914 20.4393 19.9956 20.3822 19.9882 20.326C19.9002 19.444 19.1062 15.5 12.0002 15.5C4.89422 15.5 4.10022 19.444 4.01122 20.326C4.00398 20.3823 4.00831 20.4394 4.02396 20.4939C4.03961 20.5484 4.06624 20.5982 4.10222 20.642Z",
    fill: "#5F6D8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileicon);
export default __webpack_public_path__ + "static/media/profileicon.1d84d612b55d10c5da997a208370a8b2.svg";
export { ForwardRef as ReactComponent };